import { api } from '../api.js';

// 获取资产列表
export const getAssets = (params) => {
  return api.get('/assets', { params });
};

// 获取资产详情
export const getAsset = (id) => {
  return api.get(`/assets/${id}`);
};

// 创建资产
export const createAsset = (data) => {
  return api.post('/assets', data);
};

// 更新资产
export const updateAsset = (id, data) => {
  return api.put(`/assets/${id}`, data);
};

// 删除资产
export const deleteAsset = (id) => {
  return api.delete(`/assets/${id}`);
};

// 批量删除资产
export const batchDeleteAssets = (ids) => {
  return api.delete('/assets/batch', { data: ids });
};

// 获取资产统计信息
export const getAssetStatistics = (params = {}) => {
  return api.get('/assets/statistics', { params });
};

// 更新资产状态（后端为 PUT /api/assets/{id}/status）
export const updateAssetStatus = (id, status) => {
  return api.put(`/assets/${encodeURIComponent(String(id))}/status`, null, {
    params: { status }
  });
};

// 获取资产分类列表
export const getAssetCategories = (endpoint = '') => {
  return api.get(`/asset-categories${endpoint}`);
};

// 创建资产分类
export const createAssetCategory = (data) => {
  return api.post('/asset-categories', data);
};

// 更新资产分类
export const updateAssetCategory = (id, data) => {
  return api.put(`/asset-categories/${id}`, data);
};

// 删除资产分类
export const deleteAssetCategory = (id) => {
  return api.delete(`/asset-categories/${id}`);
};

// 获取资产使用记录
export const getAssetUsageRecords = (assetId) => {
  return api.get(`/assets/${assetId}/usage-records`);
};

// 创建资产使用记录
export const createAssetUsageRecord = (data) => {
  return api.post('/asset-usage-records', data);
};

// 更新资产使用记录
export const updateAssetUsageRecord = (id, data) => {
  return api.put(`/asset-usage-records/${id}`, data);
};

// 删除资产使用记录
export const deleteAssetUsageRecord = (id) => {
  return api.delete(`/asset-usage-records/${id}`);
};

/**
 * 获取资产维护记录
 * - 传 assetId：某资产记录
 * - 传 tenantId：租户下全部登记
 */
export const getAssetMaintenanceRecords = (params = {}) => {
  if (typeof params === 'string') {
    return api.get('/assets/records/maintenance', { params: { assetId: params } });
  }
  return api.get('/assets/records/maintenance', { params });
};

/**
 * 登记维护（落库 asset_maintenance_records，并回写资产下次维护日期）
 * body: { assetId, maintenanceType, maintenanceDate, cost, description, nextMaintenanceDate, status, maintainerId }
 */
export const createAssetMaintenanceRecord = (data) => {
  return api.post('/assets/records/maintenance', data);
};

/** 兼容旧调用：按资产 ID 快捷登记 */
export const recordAssetMaintenance = (assetId, {
  maintenanceDate,
  maintenanceCost = 0,
  maintenanceNotes,
  maintenanceType
} = {}) => {
  return api.post(`/assets/${encodeURIComponent(String(assetId))}/maintenance`, null, {
    params: {
      maintenanceDate,
      maintenanceCost,
      maintenanceNotes,
      maintenanceType
    }
  });
};

export const updateAssetMaintenanceRecord = (id, data) => {
  return api.put(`/assets/records/maintenance/${encodeURIComponent(String(id))}`, data);
};

export const deleteAssetMaintenanceRecord = (id) => {
  return api.delete(`/assets/records/maintenance/${encodeURIComponent(String(id))}`);
};

// 导出资产数据
export const exportAssets = (params) => {
  return api.get('/assets/export', { 
    params,
    responseType: 'blob'
  });
};

// 导入资产数据
export const importAssets = (file) => {
  const formData = new FormData();
  formData.append('file', file);
  
  return api.post('/assets/import', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
}; 